export default __webpack_public_path__ + "static/Plots0102-1c6e1c6f95af96bc6ca60fbc674a8a99.jpg";